import { defineMessages } from "react-intl"

export default defineMessages({
  genericError: {
    defaultMessage: "Sorry, something went wrong, please try again soon",
    id: "src.utils.genericError",
  },
  sorryInvalid: {
    defaultMessage:
      "Sorry, invalid {erroredField} : {erroredFieldErrorMessage}",
    id: "src.utils.sorryInvalid",
  },
})
